(function () {
  document.querySelectorAll('[data-reviews-list]').forEach(function (list) {
    var perPage = parseInt(list.dataset.perPage, 10) || 10;
    var cards = Array.from(list.querySelectorAll('[data-review-card]'));
    var wrap = list.parentElement.querySelector('.customer-reviews__load-more-wrap');
    var button = wrap ? wrap.querySelector('[data-reviews-load-more]') : null;
    var shown = 0;

    function setupReadMore(card) {
      var text = card.querySelector('[data-review-text]');
      var readMoreBtn = card.querySelector('[data-read-more]');
      if (!text || !readMoreBtn || readMoreBtn.dataset.ready === 'true') return;
      readMoreBtn.dataset.ready = 'true';
      // Only show the button if the text is actually being clamped/cut off.
      if (text.scrollHeight > text.clientHeight + 1) {
        readMoreBtn.hidden = false;
        readMoreBtn.addEventListener('click', function () {
          var expanded = text.classList.toggle('is-expanded');
          readMoreBtn.textContent = expanded ? 'Show less' : readMoreBtn.dataset.label;
        });
        readMoreBtn.dataset.label = readMoreBtn.textContent;
      }
    }

    function reveal() {
      var next = cards.slice(shown, shown + perPage);
      next.forEach(function (card) {
        card.hidden = false;
        setupReadMore(card);
      });
      shown += next.length;
      if (button) button.hidden = shown >= cards.length;
    }

    cards.forEach(function (card) {
      card.hidden = true;
    });
    reveal();

    if (button) {
      button.addEventListener('click', reveal);
    }
  });

  var modal = document.querySelector('[data-review-modal]');
  if (modal) {
    var openBtn = document.querySelector('[data-open-review-modal]');
    var closeEls = modal.querySelectorAll('[data-close-review-modal]');
    var starButtons = modal.querySelectorAll('[data-star-value]');
    var ratingInput = modal.querySelector('[data-review-rating-input]');

    function setStars(value) {
      starButtons.forEach(function (btn) {
        var starValue = parseInt(btn.dataset.starValue, 10);
        btn.classList.toggle('is-active', starValue <= value);
      });
      if (ratingInput) ratingInput.value = value;
    }

    setStars(5);

    starButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setStars(parseInt(btn.dataset.starValue, 10));
      });
    });

    if (openBtn) {
      openBtn.addEventListener('click', function () {
        modal.hidden = false;
        document.documentElement.classList.add('overflow-hidden');
      });
    }

    closeEls.forEach(function (el) {
      el.addEventListener('click', function () {
        modal.hidden = true;
        document.documentElement.classList.remove('overflow-hidden');
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) {
        modal.hidden = true;
        document.documentElement.classList.remove('overflow-hidden');
      }
    });
  }
})();
